<template>
  <!-- 导航栏部分 -->
  <el-menu :default-active="activeIndex" mode="horizontal" :router="true">
    <el-menu-item index="/workplace">工作台</el-menu-item>
    <el-submenu index="2">
      <template slot="title">流程中心</template>
      <el-menu-item index="/myWork">我的待办</el-menu-item>
      <el-menu-item index="/flow?type=2">我发起的</el-menu-item>
      <el-menu-item index="/flow?type=3">我处理的</el-menu-item>
      <el-menu-item index="/flow?type=4">抄送我的</el-menu-item>
    </el-submenu>
    <el-menu-item index="3" disabled>|</el-menu-item>
    <el-menu-item index="/createFlow">发起新流程</el-menu-item>
  </el-menu>
</template>

<script>
export default {
  data() {
    return { activeIndex: '' }
  },
}
</script>